(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSelectOnDeviceConfig(
    $http, $timeout, OnDeviceConfigPaging, OnDeviceConfigService, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        printer: '=printer',
        tenant: '=resource',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerProperties/printerGoProfile/selectOnDeviceConfig/selectOnDeviceConfig.template.html',
      link: function(scope) {

        scope.paginationObject = new OnDeviceConfigPaging();
        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';
        scope.selectedGoProfile = null;

        (function() {
          getFirstPage();
        })();

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Pagination stuff
        ////////////////////////////////////
        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.list = [];
          scope.loadingPage = true;
          OnDeviceConfigService.getOnDeviceConfigsList(scope.paginationObject).then(function(listObject) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = listObject.page.totalPages;
            if (listObject.list) {
              scope.list = listObject.list;
            }
          }).catch(function(error) {});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }
        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            OnDeviceConfigService.getOnDeviceConfigsList(scope.paginationObject).then(function(listObject){
              if (listObject.list) {
                scope.list = scope.list.concat(listObject.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.item-list-nested').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.item-list-nested').off('scroll');
        });


        ////////////////////////////////////
        ////////////////////////////////////
        //////  Select & Save on printer
        ////////////////////////////////////
        scope.selectSignInProfile = function (signInProfilePreset) {
          scope.selectedGoProfile = signInProfilePreset;
        }

        scope.signInOnPrinter = function () {
          scope.printer.assignOnDeviceConfig(scope.selectedGoProfile.info._links.self.href).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'), scope.printer.info.name)
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'), scope.printer.info.name)
          });
          scope.callback();
        }

      }
    };
  }

  pxSelectOnDeviceConfig.$inject = [
    '$http', '$timeout', 'OnDeviceConfigPaging', 'OnDeviceConfigService', 'toastr', '$filter'
  ];

  angular
    .module('printix-admin')
    .directive('pxSelectOnDeviceConfig', pxSelectOnDeviceConfig);

})();
